import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  locationContainer: {
    maxHeight: '70vh',
    minHeight: '70vh',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '& .MuiSkeleton-root': {
      transform     : 'none',
      marginBottom  : theme.spacing(1)
    },
  },
  loading: {
    borderRadius: theme.spacing(0.4),
    height      : theme.spacing(5),
    padding     : theme.spacing(1),
  },
}));